/* eslint-disable react/prop-types */
import React, { useState, useCallback, useEffect, useMemo } from "react";
import axios from "axios";
import Cropper from "react-easy-crop";
import ReactSlider from "react-slider";
import { getCroppedImg } from "./getCroppedImg";
import { Avatar_01 } from "../../../../Routes/ImagePath";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChangePasswordModal from "../../../../components/modelpopup/ChangePasswordModal";
import { MODULES, getRoleName } from "../../../pages/hms/components/config";
import { useTranslation } from "react-i18next";
import {
  FaBed,
  FaCashRegister,
  FaBuilding,
  FaChartLine,
  FaEdit,
  FaCamera,
  FaEnvelope,
  FaPhone,
  FaUser,
  FaShieldAlt,
  FaKey,
  FaTimes,
  FaSave,
  FaLock,
  FaUpload,
  FaSpinner,
  FaVenusMars,
} from "react-icons/fa";

const profileStyles = `
  body.ns-profile-drawer-open {
    overflow: hidden !important;
  }

  .ns-user-profile-page-wrapper {
    background:
      radial-gradient(circle at 8% 0%, rgba(37, 99, 235, 0.07), transparent 30%),
      radial-gradient(circle at 92% 2%, rgba(34, 197, 94, 0.08), transparent 28%),
      #f8fafc;
  }

  .ns-user-profile-page {
    padding-top: 12px !important;
    padding-bottom: 24px;
    color: #0f172a;
  }

  .ns-up-hero {
    background:
      radial-gradient(circle at top left, rgba(37, 99, 235, 0.14), transparent 34%),
      radial-gradient(circle at top right, rgba(34, 197, 94, 0.10), transparent 32%),
      linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 24px;
    box-shadow: 0 16px 42px rgba(15, 23, 42, 0.075);
    padding: 18px;
    margin-bottom: 12px;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    gap: 16px;
    align-items: center;
  }

  .ns-up-avatar-wrap {
    position: relative;
    width: 116px;
    height: 116px;
    border-radius: 34px;
    overflow: hidden;
    background: #eff6ff;
    border: 4px solid #ffffff;
    box-shadow: 0 18px 42px rgba(37, 99, 235, 0.18);
    cursor: pointer;
    flex: 0 0 auto;
  }

  .ns-up-avatar-wrap img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .ns-up-avatar-overlay {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.58);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.16s ease;
    font-size: 1.45rem;
  }

  .ns-up-avatar-wrap:hover .ns-up-avatar-overlay {
    opacity: 1;
  }

  .ns-up-online-dot {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #22c55e;
    border: 3px solid #ffffff;
    box-shadow: 0 4px 10px rgba(34, 197, 94, 0.28);
  }

  .ns-up-eyebrow {
    color: #2563eb;
    font-size: 0.72rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    font-weight: 950;
    margin-bottom: 6px;
  }

  .ns-up-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex-wrap: wrap;
  }

  .ns-up-title-row h2 {
    color: #001f5b;
    font-size: 1.55rem;
    line-height: 1.12;
    font-weight: 950;
    margin: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ns-up-sub {
    color: #64748b;
    font-size: 0.84rem;
    line-height: 1.5;
    font-weight: 760;
    margin: 7px 0 0;
    display: flex;
    align-items: center;
    gap: 7px;
    flex-wrap: wrap;
  }

  .ns-up-role-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }

  .ns-up-pill {
    min-height: 30px;
    border-radius: 999px;
    padding: 5px 10px;
    background: #ffffff;
    color: #334155;
    border: 1px solid rgba(15, 23, 42, 0.08);
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 0.72rem;
    font-weight: 950;
  }

  .ns-up-pill.success {
    background: #ecfdf5;
    color: #047857;
    border-color: #bbf7d0;
  }

  .ns-up-hero-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .ns-up-btn {
    min-height: 42px;
    border-radius: 14px;
    border: 1px solid rgba(15, 23, 42, 0.10);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0 16px;
    font-size: 0.82rem;
    font-weight: 950;
    cursor: pointer;
    white-space: nowrap;
    transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
  }

  .ns-up-btn:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .ns-up-btn.primary {
    background: linear-gradient(135deg, #1d4ed8, #2563eb);
    border-color: #1d4ed8;
    color: #ffffff;
    box-shadow: 0 14px 30px rgba(37, 99, 235, 0.18);
  }

  .ns-up-btn.success {
    background: linear-gradient(135deg, #16a34a, #22c55e);
    border-color: #16a34a;
    color: #ffffff;
    box-shadow: 0 14px 30px rgba(22, 163, 74, 0.20);
  }

  .ns-up-btn.soft {
    background: #ffffff;
    color: #334155;
  }

  .ns-up-btn.danger-soft {
    background: #fff1f2;
    color: #dc2626;
    border-color: #fecaca;
  }

  .ns-up-btn:disabled {
    opacity: 0.62;
    cursor: not-allowed;
    transform: none;
  }

  .ns-up-main-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(340px, 0.9fr);
    gap: 12px;
  }

  .ns-up-card {
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 24px;
    box-shadow: 0 16px 42px rgba(15, 23, 42, 0.07);
    overflow: hidden;
  }

  .ns-up-card-head {
    padding: 15px 17px;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    background:
      radial-gradient(circle at top right, rgba(37, 99, 235, 0.08), transparent 28%),
      #ffffff;
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
  }

  .ns-up-card-head h3 {
    color: #001f5b;
    font-size: 1.05rem;
    line-height: 1.18;
    font-weight: 950;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ns-up-card-head p {
    color: #64748b;
    font-size: 0.76rem;
    line-height: 1.42;
    font-weight: 760;
    margin: 5px 0 0;
  }

  .ns-up-card-body {
    padding: 14px;
    background: #f8fafc;
  }

  .ns-up-info-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .ns-up-info-item {
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 18px;
    padding: 12px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
  }

  .ns-up-info-icon {
    width: 38px;
    height: 38px;
    border-radius: 14px;
    background: #eff6ff;
    color: #1d4ed8;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }

  .ns-up-info-copy {
    min-width: 0;
  }

  .ns-up-info-copy span {
    display: block;
    color: #64748b;
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-weight: 950;
    margin-bottom: 5px;
  }

  .ns-up-info-copy strong {
    display: block;
    color: #0f172a;
    font-size: 0.86rem;
    line-height: 1.28;
    font-weight: 950;
    overflow-wrap: anywhere;
  }

  .ns-up-password-panel {
    display: grid;
    gap: 12px;
  }

  .ns-up-password-large {
    background:
      radial-gradient(circle at top right, rgba(22, 163, 74, 0.10), transparent 35%),
      #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 20px;
    padding: 16px;
    display: grid;
    gap: 10px;
  }

  .ns-up-password-large strong {
    color: #0f172a;
    font-size: 1rem;
    font-weight: 950;
  }

  .ns-up-password-large span {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 780;
  }

  .ns-up-access-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 10px;
  }

  .ns-up-access-item {
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 18px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 68px;
    transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
  }

  .ns-up-access-item:hover {
    transform: translateY(-1px);
    border-color: #bfdbfe;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  }

  .ns-up-access-icon {
    width: 40px;
    height: 40px;
    border-radius: 15px;
    background: #ecfdf5;
    color: #047857;
    border: 1px solid #bbf7d0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
  }

  .ns-up-access-item strong {
    color: #0f172a;
    font-size: 0.82rem;
    font-weight: 950;
    line-height: 1.22;
  }

  .ns-up-empty {
    min-height: 150px;
    color: #64748b;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    padding: 24px;
    font-weight: 820;
  }

  .ns-up-drawer-root {
    position: fixed;
    inset: 0;
    z-index: 2147483000;
    display: flex;
    justify-content: flex-end;
    background: rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(1.5px);
    -webkit-backdrop-filter: blur(1.5px);
  }

  .ns-up-backdrop {
    position: absolute;
    inset: 0;
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
  }

  .ns-up-drawer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(540px, 100vw);
    height: 100vh;
    height: 100dvh;
    z-index: 2147483001;
    background:
      radial-gradient(circle at top left, rgba(37, 99, 235, 0.12), transparent 34%),
      #f8fafc;
    box-shadow: -18px 0 52px rgba(15, 23, 42, 0.16);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ns-up-drawer.wide {
    width: min(760px, 100vw);
  }

  .ns-up-drawer-header {
    flex: 0 0 auto;
    background:
      radial-gradient(circle at top left, rgba(37, 99, 235, 0.14), transparent 36%),
      linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    padding: 18px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 14px;
  }

  .ns-up-drawer-title {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
  }

  .ns-up-drawer-icon {
    width: 48px;
    height: 48px;
    border-radius: 18px;
    background: linear-gradient(135deg, #1d4ed8, #2563eb);
    color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 14px 30px rgba(37, 99, 235, 0.22);
    flex: 0 0 auto;
  }

  .ns-up-drawer-header h4 {
    color: #001f5b;
    font-size: 1.24rem;
    line-height: 1.14;
    font-weight: 950;
    margin: 0;
  }

  .ns-up-drawer-header p {
    color: #64748b;
    font-size: 0.78rem;
    line-height: 1.42;
    font-weight: 760;
    margin: 5px 0 0;
  }

  .ns-up-close {
    width: 40px;
    height: 40px;
    border-radius: 14px;
    border: 1px solid rgba(220, 38, 38, 0.16);
    background: #fff1f2;
    color: #dc2626;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    flex: 0 0 auto;
  }

  .ns-up-drawer-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 15px 18px 112px;
    scrollbar-width: thin;
    scrollbar-color: #93c5fd #e2e8f0;
  }

  .ns-up-drawer-section {
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 20px;
    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.055);
    padding: 15px;
  }

  .ns-up-field {
    display: grid;
    gap: 7px;
    margin-bottom: 13px;
  }

  .ns-up-field:last-child {
    margin-bottom: 0;
  }

  .ns-up-field label {
    color: #0f172a;
    font-size: 0.77rem;
    font-weight: 950;
    margin: 0;
  }

  .ns-up-input,
  .ns-up-select {
    width: 100%;
    min-height: 44px;
    border-radius: 14px;
    border: 1px solid rgba(15, 23, 42, 0.12);
    background: #ffffff;
    color: #0f172a;
    font-size: 0.88rem;
    font-weight: 760;
    outline: none;
    padding: 0 13px;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .ns-up-input:focus,
  .ns-up-select:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  }

  .ns-up-drawer-footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.96);
    border-top: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 0 -14px 34px rgba(15, 23, 42, 0.08);
    padding: 13px 18px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    z-index: 4;
  }

  .ns-up-crop-shell {
    background: #0f172a;
    border-radius: 20px;
    overflow: hidden;
    height: 430px;
    position: relative;
    border: 1px solid rgba(15, 23, 42, 0.12);
  }

  .ns-up-zoom-panel {
    margin-top: 14px;
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 18px;
    padding: 14px;
  }

  .ns-up-zoom-label {
    color: #0f172a;
    font-size: 0.78rem;
    font-weight: 950;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .zoom-slider {
    width: 100%;
    height: 10px;
    margin-top: 10px;
  }

  .zoom-slider-thumb {
    height: 22px;
    width: 22px;
    background: linear-gradient(135deg, #1d4ed8, #2563eb);
    border: 3px solid #ffffff;
    border-radius: 50%;
    cursor: grab;
    top: -6px;
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.28);
  }

  .zoom-slider-track {
    background-color: #dbeafe;
    height: 10px;
    border-radius: 999px;
  }

  .zoom-slider-track-0 {
    background: linear-gradient(135deg, #1d4ed8, #2563eb);
  }

  @media (max-width: 1180px) {
    .ns-up-main-grid {
      grid-template-columns: 1fr;
    }

    .ns-up-hero {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .ns-up-hero-actions {
      grid-column: 1 / -1;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 720px) {
    .ns-user-profile-page {
      padding-left: 8px;
      padding-right: 8px;
    }

    .ns-up-hero {
      grid-template-columns: 1fr;
      text-align: left;
    }

    .ns-up-avatar-wrap {
      width: 98px;
      height: 98px;
      border-radius: 28px;
    }

    .ns-up-info-grid,
    .ns-up-access-grid {
      grid-template-columns: 1fr;
    }

    .ns-up-drawer-footer {
      display: grid;
      grid-template-columns: 1fr;
    }

    .ns-up-btn {
      width: 100%;
    }
  }
`;

const buildCdnUrl = (cdnUrl, path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(cdnUrl || "").replace(/\/+$/, "");
  const cleanPath = String(path).replace(/^\/+/, "");
  return base ? `${base}/${cleanPath}` : `/${cleanPath}`;
};

const ProfileSetting = () => {
  const { t } = useTranslation();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isCropping, setIsCropping] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [userData, setUserData] = useState({});
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const [showEditProfile, setShowEditProfile] = useState(false);
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [profileForm, setProfileForm] = useState({
    name: "",
    mobile: "",
    gender: "",
  });

  const empid = localStorage.getItem("userid");
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const cdnUrl = process.env.REACT_APP_CDN_URL;

  const profileSrc = previewImage || profileImage || Avatar_01;
  const roleName = getRoleName(userData.role) || "-";
  const userPerms = Array.isArray(userData.userperms) ? userData.userperms : [];

  const getPermissionDisplay = useCallback(
    (perm) => {
      const safeModules = MODULES && typeof MODULES === "object" ? MODULES : {};

      const displayMap = {
        [safeModules.HMS]: { name: t("HMS") || "Hotel Management", icon: FaBed },
        [safeModules.POS]: { name: t("POS") || "Point of Sale", icon: FaCashRegister },
        [safeModules.OFFICE]: { name: t("ns-office") || "Office Management", icon: FaBuilding },
        "dynamic-price-room": { name: t("Dynamic Pricing") || "Dynamic Pricing", icon: FaChartLine },
      };

      const moduleKey = Object.keys(safeModules).find((k) => safeModules[k] === perm);
      const normalizedPerm = moduleKey ? safeModules[moduleKey] : perm;

      return displayMap[normalizedPerm] || { name: String(perm || "Unknown Permission"), icon: FaShieldAlt };
    },
    [t]
  );

  const fetchUserData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/users/list?userprofile=true&userid=${empid}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        const data = response.data;

        if (data?.users?.length) {
          const user = data.users[0];

          const perms =
            user.userperms ||
            (user.userPerms ? user.userPerms.userperms : []) ||
            [];

          setUserData((prev) => ({
            ...prev,
            ...user,
            userperms: Array.isArray(perms) ? perms : [],
          }));

          if (user.profile_pic) {
            checkProfileImage(buildCdnUrl(cdnUrl, user.profile_pic));
          } else {
            setProfileImage(null);
          }
        } else {
          toast.error("User data not found.");
        }
      } else {
        toast.error("Failed to fetch user data.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Unable to load profile details.");
    }
  }, [apiUrl, cdnUrl, empid, token]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  useEffect(() => {
    if (!showEditProfile && !isCropping) return undefined;

    document.body.classList.add("ns-profile-drawer-open");

    return () => {
      document.body.classList.remove("ns-profile-drawer-open");
    };
  }, [showEditProfile, isCropping]);

  const checkProfileImage = async (profileImagePath) => {
    try {
      const response = await fetch(profileImagePath, { method: "HEAD" });
      setProfileImage(response.ok ? profileImagePath : null);
    } catch (error) {
      console.error("Error checking profile image:", error);
      setProfileImage(null);
    }
  };

  const openFilePicker = () => {
    document.getElementById("image")?.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      toast.error("Please upload a valid image file.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size should be less than 5MB.");
      return;
    }

    setSelectedImage(file);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
      setIsCropping(true);
    };
    reader.readAsDataURL(file);
  };

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleCropSave = async () => {
    try {
      setIsUploadingImage(true);

      if (!previewImage || !croppedAreaPixels) {
        toast.error("Please crop the image first.");
        return;
      }

      const croppedImage = await getCroppedImg(previewImage, croppedAreaPixels);

      const formData = new FormData();
      formData.append("image", croppedImage);
      formData.append("empid", empid);

      const response = await axios.post(`${apiUrl}/users/upload-image`, formData, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const { imageUrl, imageFile } = response.data;
        setProfileImage(imageUrl);
        localStorage.setItem("profilepic", imageFile);
        setIsCropping(false);
        setPreviewImage(null);
        setSelectedImage(null);
        toast.success("Image uploaded successfully");
      } else {
        toast.error("Failed to upload image");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      const msg = error.response?.data?.error || "Network error or server unavailable. Please try again.";
      toast.error(msg);
    } finally {
      setIsUploadingImage(false);
    }
  };

  const handleCancelCrop = () => {
    setIsCropping(false);
    setPreviewImage(null);
    setSelectedImage(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const getLastPasswordChange = () => {
    if (!userData.lastpasschange) return "Never changed";
    const lastChange = new Date(userData.lastpasschange);
    const now = new Date();
    const diffMs = now - lastChange;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (days <= 0) return "Today";
    if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;
    const years = Math.floor(months / 12);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  };

  const openEditProfile = () => {
    setProfileForm({
      name: userData?.name || "",
      mobile: userData?.mobile || "",
      gender: userData?.gender || "",
    });
    setShowEditProfile(true);
  };

  const closeEditProfile = () => setShowEditProfile(false);

  const handleProfileField = (key, val) => {
    setProfileForm((p) => ({ ...p, [key]: val }));
  };

  const saveProfile = async () => {
    const payload = {
      userid: empid,
      name: (profileForm.name || "").trim(),
      mobile: (profileForm.mobile || "").trim(),
      gender: profileForm.gender || "",
    };

    if (!payload.name) return toast.error("Name is required");
    if (!payload.mobile) return toast.error("Phone is required");

    try {
      setIsSavingProfile(true);

      const res = await axios.post(`${apiUrl}/users/update-profile`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUserData((prev) => ({
        ...prev,
        name: payload.name,
        mobile: payload.mobile,
        gender: payload.gender,
      }));

      toast.success(res?.data?.message || "Profile updated successfully");
      setShowEditProfile(false);
    } catch (error) {
      const msg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to update profile. Please try again.";
      toast.error(msg);
      console.error("update-profile error:", error);
    } finally {
      setIsSavingProfile(false);
    }
  };

  const infoCards = useMemo(
    () => [
      { label: "Full Name", value: userData.name || "-", icon: <FaUser /> },
      { label: "Email", value: userData.email || "-", icon: <FaEnvelope /> },
      { label: "Phone", value: userData.mobile || "-", icon: <FaPhone /> },
      { label: "Gender", value: userData.gender || "-", icon: <FaVenusMars /> },
      { label: "Role", value: roleName, icon: <FaShieldAlt /> },
      { label: "Password", value: getLastPasswordChange(), icon: <FaKey /> },
    ],
    [userData.name, userData.email, userData.mobile, userData.gender, roleName, userData.lastpasschange]
  );

  return (
    <>
      <div className="page-wrapper ns-user-profile-page-wrapper">
        <div className="content container-fluid ns-user-profile-page">
          <ToastContainer />

          <section className="ns-up-hero">
            <div className="ns-up-avatar-wrap" onClick={openFilePicker} title="Update profile photo">
              <img src={profileSrc} alt="Profile" />
              <span className="ns-up-avatar-overlay">
                <FaCamera />
              </span>
              <span className="ns-up-online-dot" />

              <input
                type="file"
                className="form-control d-none"
                id="image"
                onChange={handleImageChange}
                accept="image/*"
              />
            </div>

            <div style={{ minWidth: 0 }}>
              <div className="ns-up-eyebrow">User Workspace</div>

              <div className="ns-up-title-row">
                <h2 title={userData.name || "-"}>{userData.name || "-"}</h2>
                <button
                  type="button"
                  className="ns-up-btn soft"
                  onClick={openEditProfile}
                  title="Edit profile"
                >
                  <FaEdit />
                  Edit
                </button>
              </div>

              <div className="ns-up-sub">
                <FaEnvelope />
                <span>{userData.email || "-"}</span>
              </div>

              <div className="ns-up-role-row">
                <span className="ns-up-pill success">
                  <FaShieldAlt />
                  Active Profile
                </span>
                <span className="ns-up-pill">
                  <FaBuilding />
                  {roleName}
                </span>
                <span className="ns-up-pill">
                  {userPerms.length} access module{userPerms.length === 1 ? "" : "s"}
                </span>
              </div>
            </div>

            <div className="ns-up-hero-actions">
              <button type="button" className="ns-up-btn success" onClick={() => setShowChangePassword(true)}>
                <FaLock />
                Change Password
              </button>

              <button type="button" className="ns-up-btn soft" onClick={openFilePicker}>
                <FaUpload />
                Upload Photo
              </button>
            </div>
          </section>

          <div className="ns-up-main-grid">
            <section className="ns-up-card">
              <div className="ns-up-card-head">
                <div>
                  <h3>
                    <FaUser />
                    Profile Details
                  </h3>
                  <p>Identity, contact, role, and account status details for this user.</p>
                </div>
              </div>

              <div className="ns-up-card-body">
                <div className="ns-up-info-grid">
                  {infoCards.map((item) => (
                    <div className="ns-up-info-item" key={item.label}>
                      <span className="ns-up-info-icon">{item.icon}</span>
                      <span className="ns-up-info-copy">
                        <span>{item.label}</span>
                        <strong>{item.value}</strong>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="ns-up-card">
              <div className="ns-up-card-head">
                <div>
                  <h3>
                    <FaKey />
                    Security
                  </h3>
                  <p>Keep your profile secure by rotating passwords periodically.</p>
                </div>
              </div>

              <div className="ns-up-card-body">
                <div className="ns-up-password-panel">
                  <div className="ns-up-password-large">
                    <strong>Password</strong>
                    <span>Last changed: {getLastPasswordChange()}</span>
                  </div>

                  <button type="button" className="ns-up-btn success" onClick={() => setShowChangePassword(true)}>
                    <FaLock />
                    Change Password
                  </button>

                  <ChangePasswordModal
                    show={showChangePassword}
                    onHide={() => setShowChangePassword(false)}
                  />
                </div>
              </div>
            </section>
          </div>

          <section className="ns-up-card" style={{ marginTop: 12 }}>
            <div className="ns-up-card-head">
              <div>
                <h3>
                  <FaShieldAlt />
                  My Access
                </h3>
                <p>Modules assigned to your account by the administrator.</p>
              </div>
            </div>

            <div className="ns-up-card-body">
              {userPerms.length > 0 ? (
                <div className="ns-up-access-grid">
                  {userPerms.map((perm, index) => {
                    const { name, icon: Icon } = getPermissionDisplay(perm);
                    return (
                      <div key={`${perm}-${index}`} className="ns-up-access-item">
                        <span className="ns-up-access-icon">
                          <Icon />
                        </span>
                        <strong>{name}</strong>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="ns-up-empty">
                  <FaShieldAlt />
                  <span>{t("no_permissions_assigned") || "No permissions assigned"}</span>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>

      {showEditProfile && (
        <div className="ns-up-drawer-root" role="dialog" aria-modal="true" aria-label="Edit profile">
          <button type="button" className="ns-up-backdrop" onClick={closeEditProfile} aria-label="Close edit profile" />

          <div className="ns-up-drawer">
            <header className="ns-up-drawer-header">
              <div className="ns-up-drawer-title">
                <span className="ns-up-drawer-icon">
                  <FaEdit />
                </span>
                <div>
                  <div className="ns-up-eyebrow">Profile Editor</div>
                  <h4>Edit Profile</h4>
                  <p>Update your display name, phone number, and gender.</p>
                </div>
              </div>

              <button type="button" className="ns-up-close" onClick={closeEditProfile} aria-label="Close">
                <FaTimes />
              </button>
            </header>

            <main className="ns-up-drawer-body">
              <section className="ns-up-drawer-section">
                <div className="ns-up-field">
                  <label>Full Name</label>
                  <input
                    className="ns-up-input"
                    value={profileForm.name}
                    onChange={(e) => handleProfileField("name", e.target.value)}
                    placeholder="Enter full name"
                  />
                </div>

                <div className="ns-up-field">
                  <label>Phone</label>
                  <input
                    className="ns-up-input"
                    value={profileForm.mobile}
                    onChange={(e) => handleProfileField("mobile", e.target.value)}
                    placeholder="Enter phone number"
                  />
                </div>

                <div className="ns-up-field">
                  <label>Gender</label>
                  <select
                    className="ns-up-select"
                    value={profileForm.gender}
                    onChange={(e) => handleProfileField("gender", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </section>
            </main>

            <footer className="ns-up-drawer-footer">
              <button className="ns-up-btn soft" type="button" onClick={closeEditProfile} disabled={isSavingProfile}>
                Cancel
              </button>
              <button className="ns-up-btn primary" type="button" onClick={saveProfile} disabled={isSavingProfile}>
                {isSavingProfile ? <FaSpinner className="fa-spin" /> : <FaSave />}
                {isSavingProfile ? "Saving..." : "Save Profile"}
              </button>
            </footer>
          </div>
        </div>
      )}

      {isCropping && (
        <div className="ns-up-drawer-root" role="dialog" aria-modal="true" aria-label="Update profile photo">
          <button type="button" className="ns-up-backdrop" onClick={handleCancelCrop} aria-label="Close cropper" />

          <div className="ns-up-drawer wide">
            <header className="ns-up-drawer-header">
              <div className="ns-up-drawer-title">
                <span className="ns-up-drawer-icon">
                  <FaCamera />
                </span>
                <div>
                  <div className="ns-up-eyebrow">Profile Photo</div>
                  <h4>Update Profile Pic</h4>
                  <p>Crop your photo and adjust zoom before uploading.</p>
                </div>
              </div>

              <button type="button" className="ns-up-close" onClick={handleCancelCrop} aria-label="Close">
                <FaTimes />
              </button>
            </header>

            <main className="ns-up-drawer-body">
              <section className="ns-up-drawer-section">
                <div className="ns-up-crop-shell">
                  <Cropper
                    image={previewImage}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>

                <div className="ns-up-zoom-panel">
                  <div className="ns-up-zoom-label">
                    <span>Zoom</span>
                    <strong>{zoom.toFixed(1)}x</strong>
                  </div>

                  <ReactSlider
                    className="zoom-slider"
                    thumbClassName="zoom-slider-thumb"
                    trackClassName="zoom-slider-track"
                    value={zoom}
                    onChange={setZoom}
                    min={1}
                    max={3}
                    step={0.1}
                  />
                </div>
              </section>
            </main>

            <footer className="ns-up-drawer-footer">
              <button className="ns-up-btn soft" type="button" onClick={handleCancelCrop} disabled={isUploadingImage}>
                Cancel
              </button>
              <button className="ns-up-btn primary" type="button" onClick={handleCropSave} disabled={isUploadingImage}>
                {isUploadingImage ? <FaSpinner className="fa-spin" /> : <FaUpload />}
                {isUploadingImage ? "Updating..." : "Update Photo"}
              </button>
            </footer>
          </div>
        </div>
      )}

      <style>{profileStyles}</style>
    </>
  );
};

export default ProfileSetting;
